import { call, put, takeEvery } from "redux-saga/effects";

import {
  CREATE_RESULT,
  UPDATE_RESULT,
  MARK_RESULT,
  FETCH_RESULTS_BY_CANDIDATE_ID,
  GET_RESULT_BY_TEST_ID,
  GET_RESULTS_COUNT,
} from "./actionTypes";

import {
  createResultSuccess,
  createResultFailure,
  updateResultSuccess,
  updateResultFailure,
  markResultSuccess,
  markResultFailure,
  getResultByTestIdSuccess,
  getResultByTestIdFailure,
  getResultsCountSuccess,
  getResultsCountFailure,
  fetchResultsByCandidateIdSuccess,
  fetchResultsByCandidateIdFailure,
} from "./action";

import {
  createResult,
  updateResult,
  markResult,
  getResultByTestId,
  getResultsCount,
  getResultsByCandidateId,
} from "../../helpers/backend_helper";

import { toast } from "react-toastify";

function* workCreateResult({ payload }) {
  try {
    const response = yield call(createResult, payload);
    yield put(createResultSuccess(response.data));
    toast.success("Result created successfully");
  } catch (error) {
    yield put(createResultFailure(error));
  }
}

function* workFetchResultsByTestId({ payload }) {
  const { id } = payload;
  try {
    const response = yield call(getResultByTestId, id);
    yield put(getResultByTestIdSuccess(response.data));
  } catch (error) {
    yield put(getResultByTestIdFailure(error));
  }
}

function* workGetResultsCount() {
  try {
    const response = yield call(getResultsCount);
    yield put(getResultsCountSuccess(response.data));
  } catch (error) {
    yield put(getResultsCountFailure(error));
  }
}

function* workFetchResultsByCandidateId({ payload }) {
  try {
    const response = yield call(getResultsByCandidateId, payload);
    yield put(fetchResultsByCandidateIdSuccess(response.data));
  } catch (error) {
    yield put(fetchResultsByCandidateIdFailure(error));
  }
}

export default function* watchFetchResults() {
  yield takeEvery(CREATE_RESULT, workCreateResult);
  yield takeEvery(GET_RESULT_BY_TEST_ID, workFetchResultsByTestId);
  yield takeEvery(GET_RESULTS_COUNT, workGetResultsCount);
  yield takeEvery(FETCH_RESULTS_BY_CANDIDATE_ID, workFetchResultsByCandidateId);
}
